import { render, staticRenderFns } from "./homeMobilePage.vue?vue&type=template&id=541f741c&scoped=true&"
import script from "./homeMobilePage.vue?vue&type=script&lang=js&"
export * from "./homeMobilePage.vue?vue&type=script&lang=js&"
import style0 from "./homeMobilePage.vue?vue&type=style&index=0&id=541f741c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541f741c",
  null
  
)

export default component.exports